var exports = {
  "nf": "x24da60e8--657c97--link",
  "vu": "x24da60e8--657c97--active",
};

module.exports = exports;
